export const capitalize = (word: string): string => {
    if (word.length < 1) {
        return "";
    }
    return word[0].toUpperCase() + word.slice(1).toLowerCase();
}